import { render, staticRenderFns } from "./CommonScrollSelector.vue?vue&type=template&id=ff77d266&scoped=true&"
import script from "./CommonScrollSelector.vue?vue&type=script&lang=js&"
export * from "./CommonScrollSelector.vue?vue&type=script&lang=js&"
import style0 from "./CommonScrollSelector.vue?vue&type=style&index=0&id=ff77d266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff77d266",
  null
  
)

export default component.exports